import axios from "axios";
import { loadScript, removeScript } from "../utils/operate-script";

enum ScriptMenu {
  TencentCaptcha,
  TencentCaptchaSource,
  SaleSmartly,
}
const setId = (id: string) => {
  return `script-${id}-id`;
};
class ScriptCenter {
  static menu = ScriptMenu;
  static scriptMap = new Map([
    [
      ScriptMenu.TencentCaptcha,
      "https://turing.captcha.qcloud.com/TCaptcha.js",
    ],
    [
      ScriptMenu.TencentCaptchaSource,
      "https://turing.captcha.gtimg.com/1/jquery-1.11.3.min.js",
    ],
    [
      ScriptMenu.SaleSmartly,
      "https://assets.salesmartly.com/js/project_36837_38457_1704781084.js",
    ],
  ]);
  static namespaceMap = new Map([
    [ScriptMenu.TencentCaptcha, "TencentCaptcha"],
    [ScriptMenu.SaleSmartly, "ssq"],
  ]);

  static async load(order: ScriptMenu) {
    await this.ensure(order);
    return window[this.namespaceMap.get(order)!];
  }
  static async ensure(order: ScriptMenu) {
    const namespace = this.namespaceMap.get(order);
    if (!window[namespace!]) {
      const scriptId = setId(namespace!);
      const scriptSrc = this.scriptMap.get(order)!;
      await loadScript(scriptSrc, scriptId);
    }
  }
  static destory(order: ScriptMenu) {
    const scriptId = setId(this.namespaceMap.get(order)!);
    removeScript(scriptId);
  }
  static async request(order: ScriptMenu) {
    const scriptUrl = this.scriptMap.get(order)!;
    await axios.get(scriptUrl);
  }
}

export default ScriptCenter;
